import React from "react";

export default function InputTwitterUsername({ errors, register }) {
  return (
    <input
      className={`form-control ${errors.twitter_username && "is-invalid"}`}
      type="text"
      placeholder="@usuario"
      name="twitter_username"
      {...register("twitter_username", {
        pattern: {
          value: /^@.+$/,
          message: "El usuario debe empezar con @",
        },
      })}
    />
  );
}
